const HEALTH_TOURISM_CONSTANTS = {
    GET_HEALTH_TOURISM_PAGE: 'v1/page/health-tourism'
};

export default HEALTH_TOURISM_CONSTANTS;
